export const parseUniqueEntries = (serializedList: string): string[] => {
    const parsedEntries = serializedList
        .split(/[\s,;]+/)
        .map((entry) => entry.trim())
        .filter((entry) => entry.length > 0);

    return Array.from(new Set(parsedEntries));
};
